const $ = require('jquery');
global.$ = global.jQuery = $;

require('bootstrap');
